import React, { createContext, useContext, useState, useCallback } from 'react';
import api from '../services/api';
import accessRequestService from '../services/accessRequestService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken]   = useState(localStorage.getItem('shm_token'));
  const [user,  setUser]    = useState(JSON.parse(localStorage.getItem('shm_user') || 'null'));

  const persistAuth = useCallback((data) => {
    setToken(data.token);
    setUser(data.user);
    localStorage.setItem('shm_token', data.token);
    localStorage.setItem('shm_user', JSON.stringify(data.user));
  }, []);

  const login = useCallback(async (email, password, role) => {
    const data = await api.post('/auth/login', { email, password, role });
    persistAuth(data);
    return data.user;
  }, [persistAuth]);

  // OTP login — restore when email verification is re-enabled
  // const requestLoginOtp = useCallback(async (email, password, role, resend = false) => {
  //   return api.post('/auth/request-otp', { email, password, role, resend });
  // }, []);
  //
  // const verifyLoginOtp = useCallback(async (email, otp) => {
  //   const data = await api.post('/auth/verify-otp', { email, otp });
  //   persistAuth(data);
  //   return data.user;
  // }, [persistAuth]);

  const logout = useCallback(async () => {
    const storedUser = JSON.parse(localStorage.getItem('shm_user') || 'null');
    if (storedUser?.role === 'super_admin') {
      // Cancel pending bridge access requests so "Approval pending" is gone on next login.
      try {
        await accessRequestService.cancelAllPending();
      } catch {
        // Proceed with logout even if cancellation fails.
      }
    }
    api.post('/auth/logout').catch(() => {});
    setToken(null);
    setUser(null);
    localStorage.removeItem('shm_token');
    localStorage.removeItem('shm_user');
  }, []);

  // OTP login — restore requestLoginOtp, verifyLoginOtp in provider value when re-enabled
  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
